import React, { useState } from 'react'
import { push } from '@lagunovsky/redux-react-router'
import { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import ProgressCard from '../../../../components/card/ProgressCard'
import { PATH_REFERENCIAL_CONTACTS_GROUP_NEW } from '../../../../home/constants/RouteConstants'
import ContactAction from '../actions/ContactAction'
import useTitle from 'utils/customHook/useTitle'
import useActions from 'utils/customHook/useActions'
import SearchTable from 'referencial/components/SearchTable'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'

const headers = ['id', 'name', 'numberOfMembers']

const ContactsGroupsApp = () => {
    const {
        contactsGroups,
    } = useSelector(store => ({
        contactsGroups: store.ContactReducer.contactsGroups,
    }), shallowEqual)

    const [dataLoaded, setDataLoaded] = useState(false)
    const [exportData, setExportData] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(ContactAction.fetchContactsGroups()).then(() => setDataLoaded(true))
    }, [])

    useTitle(() => [{
        title: i18n.referencials,
        href: 'referencial',
    }, {
        title: i18n.contactsGroups,
        href: '/referencial/contact',
    }], [])

    useActions(() => {
        return {
            new: () => dispatch(push(PATH_REFERENCIAL_CONTACTS_GROUP_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(exportData, headers),
                        titleFile: i18n.contactsGroups,
                    },
                },
            },
        }
    }, [exportData])

    const contactsGroupsFormatted = useMemo(() => contactsGroups.map(val => ({
        id: val.code,
        name: val.name,
        numberOfMembers: `${val.numberOfMembers}`,
    })), [contactsGroups])

    if (!dataLoaded) {
        return <ProgressCard indeterminate />
    }

    return (
        <SearchTable
            title={i18n.contactsGroups}
            sessionKey={REFERENCIAL_TYPE_NAME.contactGroup}
            data={contactsGroupsFormatted}
            setExportData={setExportData}
            headers={headers}
            onClick={contactGroup => dispatch(push(`/referencial/contactGroup/${contactGroup.id}/dashboard`))}
        />
    )
}

export default ContactsGroupsApp